import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL, baseurl } from "../../_config";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import PlayersByTeamId from "./PlayersByTeamId";

const IndividualPlayer = () => {
    const navigate = useNavigate();
    const [teamsList, setTeamsList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("individual"); // ✅ Default tab is Team
    const params = useParams();
    const teamId = params?.id;
    const [playerByTeamData, setPlayerByTeamData] = useState([]);
    const [teamData, setTeamData] = useState([]);

    const fetchTeamsList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (response?.data.status === true) {
                setTeamsList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeamsList();
    }, []);

    useEffect(() => {
        if (!teamId) {
            return;
        }
        const teamsById = async () => {
            try {
                const res = await axios.get(`${baseurl}${API_URL?.getTeams}?id=${teamId}`);

                if (res?.data.status === true) {
                    setTeamData(res?.data?.data[0])
                }

            } catch {
                setTeamData([])
            }
        }

        teamsById();

    }, [teamId]);


    useEffect(() => {
        const playerTeamsById = async () => {
            if (!teamId) {
                return;
            }
            try {
                const res = await axios.get(`${baseurl}${API_URL.getPlayersByTeamId}/${teamId}}`);

                if (res?.data?.status === true) {
                    setPlayerByTeamData(res?.data?.data)
                }

            } catch {
                setPlayerByTeamData([])
            }
        }

        playerTeamsById();

    }, [teamId])

    useEffect(() => {
        if (searchTerm) {
            const filtered = teamsList?.filter(item =>
                (item.teamName && item.teamName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(teamsList);
        }
    }, [searchTerm, teamsList]);

    useEffect(() => {
        let data = teamsList;

        // ✅ Filter by active tab
        if (activeTab) {
            data = data.filter(item => item.type?.toLowerCase() === activeTab.toLowerCase());
        }

        // ✅ Search filter
        if (searchTerm) {
            data = data.filter(item =>
                (item.teamName && item.teamName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.includes(searchTerm))
            );
        }

        setFilteredData(data);
    }, [searchTerm, teamsList, activeTab]);

    const handleDelete = async (teamId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this News?");

        if (isConfirmed) {
            try {
                const response = await axios.get(`${baseurl}${API_URL?.deleteTeam}?teamId=${teamId}`);

                if (response.data.status === true) {
                    toast.success("Deleted Successfully");
                    fetchTeamsList();
                } else {
                    toast.error("Deleted Failed!");
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: activeTab === "team" ? "Team Name" : "Role",
            selector: row => (
                <div>
                    {activeTab === "team" ? (
                        <Link to={`/cricket-teams/${row.id}`}>{row.teamName}</Link>
                    ) : (
                        <p>{row.teamName}</p>
                    )}
                </div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: activeTab === "team" ? "Captain Name" : "Player Name",
            selector: row => row.captainName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.captainEmail}</h6>
                    <span>{row?.captainMobile}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    {/* <span onClick={() => onEdit(row)} title='Edit' className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#ff7722" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="#ff7722" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span> */}
                    <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        },
        // {
        //     name: 'Add Team',
        //     selector: row => (
        //         <div className="d-flex" style={{ gap: "10px" }}>
        //             <span title='Add' className="delete_icon_weepr">Add Players</span>
        //         </div>
        //     ),
        //     sortable: false,
        //     minWidth: '100px'
        // },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">{teamData?.teamName}</h4>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="add_btn">
                            <button>Add Player</button>
                        </div>
                    </div>
                </div>

                {teamId && (
                    <div className="d-flex gap-3 mt-3">
                        <button
                            className={`btn ${activeTab === "individual" ? "btn-primary" : "btn-outline-primary"}`}
                        // onClick={() => setActiveTab("individual")}
                        >
                            Individual Player List
                        </button>
                    </div>
                )}

             <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div> 
            </div>
        </Layout>
    )
}

export default IndividualPlayer;